import React from "react";
import { useSelector } from "react-redux";
import DatePicker from "main/components/DatePicker/DatePicker";
import TimePicker from "main/components/DatePicker/TimePicker";
import DocumentView from "../DocumentView";
import ET from "../EditableText";
import TopRightTitle from "../TopRightTitle";
import "./style.css";

export default function ReportInspection({
  style,
  signatureDataUrl,
  signatureDate,
  signatureTime,
  onSignatureDateChange,
  onSignatureTimeChange,
  onOpenSignatureModal,
}) {
  const inspection = useSelector((state) => state.report.inspection);

  return (
    <DocumentView style={style}>
      <div className="document-head">
        <header>
          <div className="grid-pg1">
            <div>
              <h3>
                <strong>
                  <ET
                    isPageTitle
                    titleKey="inspection"
                    reduxKey="inspection.title"
                    ml="50"
                  >
                    {inspection?.title}
                  </ET>
                </strong>
              </h3>
            </div>
            <div className="grid-pg1-item2">
              <TopRightTitle />
            </div>
          </div>
        </header>
      </div>
      <div className="doc-body template-body" style={{ position: "relative" }}>
        <ET reduxKey="inspection.text" ml="26000" innerHtml={true}>
          {inspection?.text}
        </ET>
        <div className="inspection-signature-section">
          <div className="inspection-signature-field">
            <label>Date & Time</label>
            <div className="inspection-signature-datetime">
              <DatePicker
                value={signatureDate}
                setValue={(value) => onSignatureDateChange?.(value)}
                label="Date"
              />
              <TimePicker
                value={signatureTime}
                setValue={(value) => onSignatureTimeChange?.(value)}
                label="Time"
              />
            </div>
          </div>
          <div className="inspection-signature-field">
            <label>Signature</label>
            <div
              className="inspection-signature-preview"
              onClick={onOpenSignatureModal}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  onOpenSignatureModal?.();
                }
              }}
            >
              {signatureDataUrl ? (
                <img src={signatureDataUrl} alt="Signature" />
              ) : (
                <span>Signature</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </DocumentView>
  );
}
